import { memo, type RefObject } from 'react';

import { SettingNavigatorContainer } from 'app/modules/wallforming/components/setting-container/SettingNavigatorContainer';
import { SettingOptionsLayout } from 'app/modules/wallforming/components/setting-container/SettingOptionsLayout';

import type { Model } from 'flexlayout-react';

interface SettingContainerProps {
    settingModelRef?: RefObject<Model | null>;
}

export const SettingContainer = memo(({ settingModelRef }: SettingContainerProps) => {
    return (
        <div className="flex h-full min-h-0 w-full min-w-0 flex-row">
            <SettingOptionsLayout settingModelRef={settingModelRef} />
            <SettingNavigatorContainer />
        </div>
    );
});

SettingContainer.displayName = 'SettingContainer';
